<template>
  <div>
    <!--创建容器-->
    <div id="mapDiv" style="position: absolute; width: 98%; height: 97%"></div>
  </div>
</template>
<script>
import T from "tMap"; // 天地图引入
import mapMixin from "@/lib/map/mapMixin"; // 公共方法
export default {
  mixins: [mapMixin],
  data() {
    return {
      map: "", // 对象
      zoom: 16, // 地图的初始化级别，及放大比例
    };
  },
  mounted() {
    let that = this;
    // 挂载完成后渲染地图
    this.$nextTick(function () {
      that.onLoad();
    });
  },
  methods: {
    onLoad() {
      let that = this;
      that.map = new T.Map("mapDiv");
      that.map.centerAndZoom(
        new T.LngLat(103.52448655029296, 30.586333903640934),
        that.zoom
      ); // 设置显示地图的中心点和级别
      //创建缩放平移控件对象
      let control = new T.Control.Zoom();
      // 添加地图类型控件
      that.addCtrl(control);

      // 普通标注
      let site = [
        { lng: 103.52567745109558, lat: 30.589344813247102 },
        { lng: 103.52193308731079, lat: 30.582537807635234 },
        { lng: 103.51666522880554, lat: 30.58205751238934 },
      ];
      that.markerPoint(site);
    },
  },
};
</script>